<template>
  <div class="chart-bag">
    <div id="energyChart">
      <div id="legend"></div>
      <div id="totalValue">
        累積耗電量：<p></p>
      </div>
    </div>
    <div id="right-chart">
      <div id="pieChart">
        <div id="pieLegend"></div>
      </div>
      <div id="energy-consumption">
        <div>
          <i class="fa-solid fa-chart-column"></i>
          <p>每月趨勢</p>
        </div>
        <div>
          <i class="fa-solid fa-sack-dollar"></i>
          <p>每月電費</p>
        </div>
        <div>
          <i class="fa-solid fa-plug"></i>
          <p>每月消耗</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import energyConsumptionPieChart from '../library/energyConsumptionPieChart';
import createCircularBar from '../library/createCircularBar';
import createPieChar from '../library/createPie';
import { axiosMixins } from './mixins/axiosErrorMessage';

export default {
  mixins: [axiosMixins],
  data() {
    return {
      legend_array: [
        ["red", "Peak"],
        ["yellow", "Moderate"],
        ["gray", "Off-peak"],
      ],
      carbon_coe: '',
    };
  },
  computed: {
    meter() {
      return this.$store.getters.selectedMeter
    },
  },
  methods: {
    getBxLog() {
      const cumulative_data = this.meter.bx_circuits[0].cumulative_data;
      this.initChart();
      this.createPie(cumulative_data);
      this.createCircularBar(cumulative_data);
      this.createTotalValue(cumulative_data);
      this.energyConsumptionPieChart();
    },
    initChart() {
      const old_bar = this.$el.querySelector("#bar-svg");
      const old_pie = this.$el.querySelector("#pie-svg");
      const old_legend = this.$el.querySelector("#legend-svg");

      if (old_bar) { old_bar.remove(); }
      if (old_pie) { old_pie.remove(); }
      if (old_legend) { old_legend.remove(); }
    },
    // 總電量外圍顯示用量狀態
    createPie(data) {
      const sortedKWhValues = data
        .map((entry) => entry.kWh)
        .sort((a, b) => a - b);
      const Q2 = sortedKWhValues[Math.floor(sortedKWhValues.length / 2)];
      const Q3 = sortedKWhValues[Math.floor((3 * sortedKWhValues.length) / 4)];

      // 設置顏色
      data.forEach((entry) => {
        if (entry.kWh < 1 || entry.kWh < Q2) {
          entry.color = this.legend_array[2][0];
        } else if (entry.kWh < Q3) {
          entry.color = this.legend_array[1][0];
        } else {
          entry.color = this.legend_array[0][0];
        }
      });

      const height = parseInt(d3.select('#energyChart').style("height"), 10);
      const createPie = {
        data: data,
        width: height,
        height: height,
        radius: height / 2,
        innerRadius: height * 0.38,
        legendItemSize: 12,
        legendSpacing: 4,
        legend_array: this.legend_array
      }

      createPieChar(createPie);
    },
    // 總電量圓形條狀圖
    createCircularBar(data) {
      const height = parseInt(d3.select('#energyChart').style("height"), 10);
      const margin = height * 0.26
      const createCircularBarParams = {
        data: data,
        width: height,
        height: height,
        innerRadius: height * 0.13,
        outerRadius: (height - margin) / 2,
        dataColumns: ["kWh"],
      }

      createCircularBar(createCircularBarParams);
    },
    // 總電量外，其餘電路耗電比例
    energyConsumptionPieChart() {
      // 線路一為總耗電量
      let circuitData = JSON.parse(JSON.stringify(this.meter.bx_circuits));
      circuitData.splice(0, 1)

      let data = [];
      let count = 0;

      // 取得電度值並將其存成陣列
      for (let i = 0; i < circuitData.length; i++) {
        let filtered = [];
        filtered = circuitData[i].cumulative_data.filter(value => {
          return value.cumulative_ep;
        });
        if (filtered.length > 0) {
          data[count] = {
            alias: circuitData[i].alias,
            cumulative_ep: filtered[filtered.length - 1].cumulative_ep,
          };
          count++
        }
      }
      const height = parseInt(d3.select('#pieChart').style("height"), 10);

      const energyConsumptionParams = {
        data: data,
        width: height,
        height: height,
        radius: height / 2,
        legendItemSize: 12,
        legendSpacing: 4,
        config: {
          padding: { top: height / 30, left: height / 30, right: height / 30, bottom: height / 30 },
          margin: { top: height / 5, left: height / 5, bottom: height / 5, right: height / 5 },
          textColor: "black",
          title: "各線路耗電比例",
          innerRadius: 0,
          outerRadius: height / 4,
          textOffsetH: 10,
          lineColor: "black",
          animateDuration: 0,
        }
      }
      energyConsumptionPieChart(energyConsumptionParams)
    },
    // 耗電量總計
    createTotalValue(data) {
      const showValue = Math.max(...data.map(item => {
        return item.cumulative_ep;
      }).filter(d => d))

      // 依渲染圖表大小，設定總耗電量字型大小
      const height = parseInt(d3.select('#energyChart').style("height"), 10);
      this.$el.querySelector("#totalValue").style.fontSize = height / 600 + "rem"
      this.$el.querySelector("#totalValue").querySelector("p").innerText = Math.round(showValue * 10) / 10 + " kWh";
    },
    // TODO: 取得碳排量
    getCarbonCoe() {
      axios.get("https://data.moenv.gov.tw/api/v2/cfp_p_02?language=zh&offset=12&limit=999999999&api_key=35f69294-2e88-4185-9e51-1a77bea4825a")
        .then((response) => {
          this.carbon_coe = response.data;
          console.log(this.carbon_coe);
        }).catch(error => this.axiosMessage(error));
    }
  },
  mounted() {
    this.getBxLog();
  },
};
</script>

<style scoped>
.chart-bag {
  display: flex;
  justify-content: center;
  height: 60vh;
}

#energyChart {
  position: relative;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#legend {
  position: absolute;
  left: 500px;
  bottom: 50px;
}

#totalValue {
  line-height: 1rem;
  height: 30px;
}

#right-chart {
  position: relative;
  width: 50%;
}

#pieChart {
  position: relative;
  height: 45vh;

}

#pieLegend {
  position: absolute;
  right: 150px;
  bottom: 0;
}

#energy-consumption {
  padding-top: 2%;
  display: flex;
  justify-content: space-around;
}

#energy-consumption svg {
  width: 70px;
  height: 70px;
}


#energyChart svg {
  position: absolute;
}


#pie-svg:nth-child(1) {
  z-index: 3;
}

#bar-svg:nth-child(2) {
  z-index: 2;
}

#gauge-svg:nth-child(3) {
  z-index: 1;
}

#gauge-svg .title {
  width: 100px;
  background-color: gray;
  border-bottom: 2px solid black;
}
</style>
